/**
 * exatrek REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: v3
 * Contact: dev@exatrek.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { LocationDatasetV2Dto } from './locationDatasetV2Dto';
import { MachineIdDto } from './machineIdDto';

export interface MachineLocationSetV2Dto {
  jobId?: number;
  locations?: Array<LocationDatasetV2Dto>;
  machine?: MachineIdDto;
}
